import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteConfig } from '../config/siteConfig';
import { FileText } from 'lucide-react';
import PageHeader from '../components/PageHeader';

const Disclaimer: React.FC = () => {
    const { t } = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-maat-stone min-h-screen">
            <PageHeader
                title={t.legal.disclaimerTitle}
                subtitle={t.legal.disclaimerSubtitle}
            />

            {/* Content Section */}
            <section className="py-20 font-sans">
                <div className="container mx-auto px-6">
                    <div className="max-w-4xl mx-auto">
                        <div className="bg-white p-8 md:p-12 rounded-4xl border border-maat-sand shadow-sm">
                            <div className="flex items-center space-x-4 mb-8">
                                <div className="p-3 bg-maat-stone rounded-2xl">
                                    <FileText className="text-maat-gold" size={32} />
                                </div>
                                <h2 className="text-3xl font-serif text-maat-blue">{t.legal.disclaimerTitle}</h2>
                            </div>
                            <div className="prose prose-lg prose-slate text-maat-blue/80 leading-relaxed max-w-none">
                                {t.legal.disclaimerText.split('\n\n').map((paragraph, index) => (
                                    <p key={index} className="mb-6 last:mb-0">
                                        {paragraph}
                                    </p>
                                ))}
                            </div>
                        </div>

                        <div className="bg-white p-8 md:p-12 rounded-4xl border border-maat-sand shadow-sm mt-8">
                            <h2 className="text-2xl font-serif text-maat-blue mb-6">{t.company.detailsTitle}</h2>
                            <div className="text-maat-blue/80 leading-relaxed">
                                <p className="font-bold text-maat-blue">{siteConfig.legalName}</p>
                                <p className="mt-4">{t.company.kvkLabel} {siteConfig.kvk}</p>
                                {siteConfig.vat && <p>{t.company.vatLabel} {siteConfig.vat}</p>}
                                <p className="mt-4">{siteConfig.social.emailLabel}</p>
                            </div>
                        </div>

                        <div className="text-center pt-12">
                            <a
                                href={`mailto:${siteConfig.social.email}`}
                                className="text-maat-gold font-bold hover:underline"
                            >
                                {siteConfig.social.emailLabel}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Disclaimer;
